import * as Immutable from 'immutable';
import ListingStore from '../../../UserData/_stores/Store/ListingStore';
import PurchaseReportStore from '../../../UserData/_stores/Store/PurchaseReportStore';

export interface IAccountStore {
  productDesignSelectedProducts: Immutable.OrderedSet<number>
  productDesignSelectedAllProducts: boolean
  productDesignExcludedSelectedProducts: Immutable.OrderedSet<number>
  productDesignSelectionClearCounter: number
  imageSelectedImages: Immutable.OrderedSet<number>
  imageSelectedAllImages: boolean
  imageExcludedSelectedImages: Immutable.OrderedSet<number>
  imageSelectionClearCounter: number
  storeSelectedProducts: Immutable.OrderedSet<number>
  storeSelectedAllProducts: boolean
  storeExcludedSelectedProducts: Immutable.OrderedSet<number>
  storeProductSelectionClearCounter: number
  storeProductListings: Immutable.Map<string, ListingStore>
  storeProductSelectedListing: string
  storePurchaseReports: Immutable.Map<string, PurchaseReportStore>
}

export const AccountStoreFactory = Immutable.Record<IAccountStore>({
  productDesignSelectedProducts: Immutable.OrderedSet<number>(),
  productDesignSelectedAllProducts: false,
  productDesignExcludedSelectedProducts: Immutable.OrderedSet<number>(),
  productDesignSelectionClearCounter: 0,
  imageSelectedImages: Immutable.OrderedSet<number>(),
  imageSelectedAllImages: false,
  imageExcludedSelectedImages: Immutable.OrderedSet<number>(),
  imageSelectionClearCounter: 0,
  storeSelectedProducts: Immutable.OrderedSet<number>(),
  storeSelectedAllProducts: false,
  storeExcludedSelectedProducts: Immutable.OrderedSet<number>(),
  storeProductSelectionClearCounter: 0,
  storeProductListings: Immutable.Map<string, ListingStore>(),
  storeProductSelectedListing: "",
  storePurchaseReports: Immutable.Map<string, PurchaseReportStore>(),
});

export default class AccountStore extends AccountStoreFactory {}
